import React, { useEffect, useRef, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import { Card, Col, Row } from "antd";
import axios from "../services/axios";
import { message } from "antd";
import moment from "moment";
import ReactLoading from "react-loading";
import { DatePicker } from "antd";
import exportFromJSON from "export-from-json";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import isConsultant from "../services/isConsultant";
import { Select } from "antd";
import { checkPermission } from "../utils/checkPermission";
import useRole from "../hooks/useRole";

const { RangePicker } = DatePicker;
const { Option } = Select;

const AssignTrfReport = (props) => {
  const location = useLocation();

  const [defaultDate, setDefaultDate] = useState([]);
  const [trfList, setTrfList] = useState([]);
  const [users, setUsers] = useState([]);
  const [trf, setTrf] = useState("");
  const [user, setUser] = useState("");
  const [load, setLoad] = useState(false);
  const [disabbled, setDisabbled] = useState(true);

  const [canViewDistributedTrf, setCanViewDistributedTrf] = useState(false);
  const [canDownloadDistributedTrf, setCanDownloadDistributedTrf] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const viewAllowed = await checkPermission(
        userRole,
        "distributed_trf_report_module",
        "view_distributed_trf"
      );
      const downloadAllowed = await checkPermission(
        userRole,
        "distributed_trf_report_module",
        "download_distributed_trf"
      );
      setCanViewDistributedTrf(viewAllowed);
      setCanDownloadDistributedTrf(downloadAllowed);
    } catch (err) {
      console.error("Error checking distributed TRF report permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  //   const disabledDate = (current) => {
  //     return moment().startOf('day');
  //   };

  const initialRender = useRef(false)

  useEffect(() => {
      if(initialRender.current){
        setDisabbled(false)
      }

      initialRender.current = true
  }, [defaultDate, trf, user]);


  const id = localStorage.getItem("user.id");

  const loadCSV = async () => {
    setLoad(true);
    await axios
      .get(
        `/trfBasedUserMapping/Reports/DownloadDistributedTRFReports?TRFId=${trf}&StartDate=${
          defaultDate[0]
            ? defaultDate[0]?._i
            : ""
        }&EndDate=${
          defaultDate[1]
            ? defaultDate[1]?._i
            : ""
        }&userId=${user}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`
          }
        }
      )
      .then((res) => {
        const result = res.data;
        //  console.log("RES", res.data);
        const flattenArray = result?.map((ele) => {
          let flatObject = { ...ele };
          function flatten(obj, keyPrefix) {
            Object.keys(obj).forEach((key) => {
              if (typeof obj[key] === "object") {
                Object.assign(flatObject, obj[key]);
                delete flatObject[key];
              }
            });
          }
          flatten(ele, "");
          return flatObject;
        });
        const data = flattenArray;
        downloadCSV(data)
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
        message.warning("Error Occured", 2);
        setLoad(false);
      });
  };

  const handleDate = (value, dateString) => {
    if (value === null) {
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD")
      ]);
    } else {
      let startDate = moment(dateString[0], "YYYY-MM-DD");
      let endDate = moment(dateString[1], "YYYY-MM-DD");
      if (moment(endDate).isAfter(moment(startDate).add(60, "days"))) {
        swal({
          title: "You can not select data more than 60 days",
          icon: "error"
        });
      } else {
        setDefaultDate([startDate, endDate]);
      }
    }
  };

  const onOk = (value) => {
    // console.log("onOk:", value);
  };

  const getTrf = () => {
    axios
      .get(`/trf?Department=&Location=&isTRFAssigned=&trfStatus=${true}&isTRFAssignable=${true}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`
        }
      })
      .then((res) => {
        setTrfList(res.data);
      });
  };


  const getUsers = () => {
    axios
      .get(`/user`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`
        }
      })
      .then((res) => {
        setUsers(res.data);
      });
  };

  useEffect(() => {
    getUsers()

    getTrf();
  }, []);

  //CSV DATA
  const exportType = "csv";
  let fileName = `DISTRIBUTED_TRF_REPORT_${moment(new Date()).format(
    "DD-MM-YYYY_HH:mm"
  )}`;

  // const downloadCSV = async() => {
  //   if(defaultDate.length === 0){
  //     swal({
  //       title: "Please select date range",
  //       icon: "error",
  //     })
  //   }
  //   else{
  //     const flattenArray =await csvData?.map(ele => {
  //       let flatObject = {...ele};
  //       function flatten(obj, keyPrefix) {
  //         Object.keys(obj).forEach(key => {
  //           if (typeof obj[key] === 'object') {
  //             Object.assign(flatObject, obj[key]);
  //             delete flatObject[key];
  //           }
  //         });
  //       }
  //       flatten(ele, '');
  //       return flatObject;
  //     });
  //     const data = flattenArray;
  //   setCurrent(1);
  //   exportFromJSON({ data, fileName, exportType });
  //   }
  // };

  const downloadCSV = async (_data) => {
    const flattenArray = (data) => {
        console.log(data)
      if (!data) return [];
      return data.map((ele) => {
        let flatObject = { ...ele };
        function flatten(obj) {
          Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
              Object.assign(flatObject, obj[key]);
              delete flatObject[key];
            } else if (Array.isArray(obj[key])) {
              console.log("inside array key", obj[key]);
              flatObject[key] = obj[key].toString();
            }
          });
        }

        flatten(ele);
        return flatObject;
      });
    };
    const data = flattenArray(_data);
    exportFromJSON({ data, fileName, exportType });
  };

  const disabledDate = (current) => {
    // Disable future dates
    return current && current > moment().endOf("day");
  };

  return (
    <Dashboard title="Distributed Trf Report">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      {canViewDistributedTrf ? (
        <Card>
          <div className="row ">
            <div className="col-md-4">
              <label htmlFor="candidate photo">Select Trf</label>
              <Select
                showSearch
                style={{ width: "100%", height: "37px" }}
                placeholder="Select Trf"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  return (
                    option?.children
                      ?.toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
                }}
                onChange={(value) => setTrf(value)}>
                {trfList?.map((option) => (
                  <Option value={option?._id}>{`${option?.title}-${
                    option?.department
                  }-${option?.location}-${option?.processName}-${moment(
                    option?.tat
                  )
                    .utc()
                    .format("YYYY-MM-DD")}${
                    option?.workModal ? `-${option.workModal}` : ""
                  }`}</Option>
                ))}
              </Select>
            </div>    
            <div className="col-md-4">
              <label htmlFor="candidate photo">
                Trf Assign Date
              </label>
              <RangePicker
                format="YYYY-MM-DD"
                style={{ width: "100%" }}
                // defaultValue={[moment(), moment()]}
                onChange={handleDate}
                onOk={onOk}
                disabledDate={disabledDate}
                placeholder={[
                  moment(new Date()).format("YYYY-MM-DD"),
                  moment(new Date()).format("YYYY-MM-DD")
                ]}
              />
            </div>
            <div className="col-md-4">
              <label htmlFor="candidate photo">Select Recruiter</label>
              <Select
                showSearch
                style={{ width: "100%", height: "37px" }}
                placeholder="Select Recruiter"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  return (
                    option?.children
                      ?.toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
                }}
                onChange={(value) => setUser(value)}>
                {users?.map((user) => (
                  user?.role === 'interviewer' &&
                  <Option value={user?._id}>{user?.name}</Option>
                ))}
              </Select>
            </div>
            {canDownloadDistributedTrf && (
              <div className="col-md-3 mt-4 align-items-end d-flex">
                <button
                  disabled={disabbled}
                  className={`btn ${
                    disabbled ? "btn-secondary" : "btn-primary"
                  } btn-block`}
                  onClick={loadCSV}>
                  Download CSV
                </button>
              </div>
            )}
          </div>
        </Card>
      ) : (
        !load && <Card>You are not authorized to view this report.</Card>
      )}
    </Dashboard>
  );
};

export default AssignTrfReport;
